import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'store/store';
import { ThemeProvider } from 'styled-components';
import theme from 'themes/specsavers';
import CssBaseline from 'CssBaseline';
import App from 'App';
import Typography from 'foundation/Typography';
import ErrorBoundary from 'ErrorBoundary';
import { initializeTagManager } from 'lib/GoogleTagManager';

initializeTagManager();

ReactDOM.render(
  (
    <ThemeProvider
      theme={theme}
    >
      <CssBaseline />
      <Typography />
      <ErrorBoundary>
        <Provider store={store}>
          <App />
        </Provider>
      </ErrorBoundary>
    </ThemeProvider>
  ),
  document.getElementById('root'),
);
